import { render, staticRenderFns } from "./AddedDependenciesList.vue?vue&type=template&id=7b83c869&"
import script from "./AddedDependenciesList.vue?vue&type=script&lang=js&"
export * from "./AddedDependenciesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports